import React, { ComponentProps } from 'react';

import { Button } from 'antd';

type AntdButtonProps = ComponentProps<typeof Button>;

/**
 * @deprecated Use `Button` from `@common/components` instead.
 */
export const BaseButton = ({
  postIcon,
  ...props
}: AntdButtonProps & {
  postIcon?: React.ReactElement | null;
}) => (
  <>
    <Button {...props} className={`wk-base-button ${props.className || ''}`}>
      {props.children}
      {postIcon}
    </Button>
    <style jsx>{`
      :global(.wk-base-button svg + span) {
        margin-left: 0.7em;
      }
      :global(.wk-base-button span + svg) {
        margin-left: 0.7em;
      }
    `}</style>
  </>
);
